// Closes the header Catalogue disclosure on outside click and on Escape (returning focus to its summary).
const menus = () => document.querySelectorAll('details[data-catalogue-menu][open]');

document.addEventListener('click', (event) => {
  for (const menu of menus()) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const menu of menus()) {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  }
});
